// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".percentageBar[data-v-2a1f0832] {\n  width: 100%;\n  height: 25px;\n  margin: 0 0 15px 0;\n}\n.percentageBar canvas[data-v-2a1f0832] {\n  border-radius: 3px;\n  background-color: #ffffff;\n  width: 100%;\n  height: 25px;\n}\n.percentageBar__status[data-v-2a1f0832] {\n  z-index: 2;\n  color: white;\n  top: 0;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
